// extracted by mini-css-extract-plugin
export default {"container":"carousel_container__KLCck"};